import { Avatar, AvatarImage, AvatarFallback } from "../../components/ui/avatar";
import { cn } from "../../lib/utils";
import { Util } from "../../services/Utils/Util";

interface UserAvatarProps {
    src?: string | null;
    name?: string;
    className?: string; // Avatar size classes (e.g. w-10 h-10)
    onClick?: () => void;
    fallbackType?: "text" | "image"; // Optional: force specific fallback type if needed, default is centralized logic
}

export function UserAvatar({ src, name, className, onClick, fallbackType = "text" }: UserAvatarProps) {
    // Centralized Logic for Fallback
    // If you want to change default fallback to 'image' globally, change this variable.
    const globaDefaultFallback = "text";
    const effectiveFallback = fallbackType === "text" ? globaDefaultFallback : fallbackType;

    return (
        <Avatar className={cn(className)} onClick={onClick}>
            <AvatarImage src={src || ""} className="object-cover rounded-[var(--radius-avatar)]" />
            <AvatarFallback className="bg-muted p-[15%]">
                {/* SVG Text for perfect scaling */}
                <svg viewBox="0 0 100 100" className="w-full h-full fill-current text-gray-500">
                    <text
                        x="50"
                        y="50"
                        dy=".35em"
                        textAnchor="middle"
                        fontSize="55"
                        fontWeight="bold"
                        fontFamily="sans-serif"
                    >
                        {name?.charAt(0).toUpperCase() || "?"}
                    </text>
                </svg>

                {/* 
           If you want to use an image as fallback globally later, 
           you can comment out the SVG above and uncomment the IMG below,
           or switch logic based on 'effectiveFallback'.
        */}
                {/* <img src={Util.ANONYMOUS_PHOTO_URL} className="w-full h-full object-cover opacity-50" /> */}
            </AvatarFallback>
        </Avatar>
    );
}
